// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"styles_Navigation__2Cvfi","Navigation-item":"styles_Navigation-item__16TPh"};